import PropTypes from 'prop-types';
export var articleProps = {
  title: PropTypes.string,
  url: PropTypes.string,
  image: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired
  }))
};
export default {
  articles: PropTypes.arrayOf(PropTypes.shape(articleProps))
};